import React, { Component } from 'react';
import FilterComponent from "./FilterComponent";
import FilterStore from '../store/FiltersStore'
import { Icon, Step, Segment, Button,Image, Form, TextArea } from 'semantic-ui-react'
import * as esriLoader from 'esri-loader';
import ChatComponent from "./ChatComponent";

export default class FilterListComponent extends Component {

    constructor() {
        super();
        window.globalBuildingsURL =
          "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/LPC_HistoricBuildings_Service/FeatureServer/0";
        this.bldgsLayers = ["198f727cb84-layer-13"]
        //198f727cb84-layer-13 - dev
        //198423afa22-layer-13 - prod
          // ["LPC_HistoricBuildings_Service_768"]
        this.hdURL = "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Historic_Districts/FeatureServer/0" + "/query?" +
          "returnGeometry=true&returnCentroid=false&returnCountOnly=false&returnDistinctValues=false";
        this.ilURL = "https://services5.arcgis.com/Oos4pNA2538iVFA1/ArcGIS/rest/services/Individual_Landmark_Lots_Poly/FeatureServer/0" + "/query?" +
          "returnGeometry=true&returnCentroid=false&returnCountOnly=false&returnDistinctValues=false";

        this.filterStores = this.initFilterStores();
        this.state = {
            filterStores : this.filterStores,
            updatingFilterStores: {},
            tabSelected: 'search',
            filterSelected: false,
            resultCount: 0,
            updatingResults: false,
            aiMode: false,
            chatResult: null,
        };
    }

    initFilterStores () {
        return {
            "Hist_Dist"  : new FilterStore("Hist_Dist"),
            "LM_New"     : new FilterStore("LM_New"),
            "Style_Prim" : new FilterStore("Style_Prim"),
            "Arch_Build" : new FilterStore("Arch_Build"),
            "Build_Type" : new FilterStore("Build_Type"),
            "ERA"        : new FilterStore("ERA"),
        };
    }

    componentDidMount() {
        this.startUpdatingFilters(null, null);
    }

    tabChanged(tabSelected) {
        //this.props.updateResultsOnFilterUpdate();
        if(tabSelected==="aiChatBox") {
            this.setState({aiMode : true})
        }
        else {
            this.setState({aiMode : false})
            if(tabSelected==="search") {

            }
            else {
                this.props.handleResultsClick();
            }
        }
    }

    resetFilter() {
        Object.keys(this.filterStores).forEach(
          (storeKey) => {
              this.filterStores[storeKey].clearAllFilters();
          }
        )
        this.filterStores = this.initFilterStores()
        this.setState({filterStores : this.filterStores})
        this.startUpdatingFilters(null, null);
        this.setState({filterSelected:false})
        this.updateMap(this.createWhereClause())
        if (typeof this.polygonLayer !== "undefined") {
            window.globalMap.removeLayer(this.polygonLayer);
        }
    }

    renderButtons() {
       return (
         <table width="100%"><tbody>
         <tr>
             <td width="43%"><Button fluid style={ { "backgroundColor": "#C1272C", "color": "#fff" } } disabled={!this.state.filterSelected}
                                     onClick={this.resetFilter.bind(this)}>RESET</Button></td>
             <td width="43%"><Button fluid style={ { "backgroundColor": "#8EB74F", "color": "#fff" } } disabled={!this.state.filterSelected}
                                     onClick={this.tabChanged.bind(this, 'results')}>RESULTS</Button></td>
             <td width="14%"><Button fluid style={ { "backgroundColor": "#C1272C", "color": "#fff" } } disabled={this.state.filterSelected}
                                     onClick={this.tabChanged.bind(this, 'aiChatBox')}><Image src='SearchAI-full.png' /></Button></td>
         </tr>
         </tbody></table>
       )
    }

    getFilterComponent(filterKey, includeGoto) {
        var gotoBtn = []
        if(includeGoto)
            gotoBtn.push(<Button color="green" fluid compact circular disabled>Go To</Button>)

        return (
          <div>
            <FilterComponent key={filterKey} filterName={filterKey} filterText={filterKey}
                         filters={this.state.filterStores[filterKey].getAvailableFilters()}
                         isFetching={this.state.updatingFilterStores[filterKey]}
                         handleUpdate={this.handleFilterUpdate.bind(this)}/>
          {gotoBtn}
          </div>
        )
    }

    renderFilters(filtersKey) {
        var filters = [];
        for(var i=0;i<filtersKey.length;i++) {
            filters.push(this.getFilterComponent(filtersKey[i],false))
        }
        return (<div>{filters}</div>)
    }

    renderStandardFilters() {
        return(
            <div>
                {this.renderFilters(["Hist_Dist", "LM_New"])}
                <hr /><br />
                <b>Or, filter by attribute:</b><br /><br />
                {this.renderFilters(["Style_Prim", "Arch_Build", "Build_Type", "ERA"])}
            </div>
        )
    }
    renderAIfilter() {
        return (
          <ChatComponent
            handleCancel={this.tabChanged.bind(this, 'search')}
            handleSuccessfulSearch={this.updateChatResult.bind(this)}
          />
        )
    }

    updateChatResult(chatResult) {
        // console.log("updateChatResult", chatResult);
        this.setState({whereClause:chatResult})
        this.props.updateResultsOnFilterUpdate(chatResult);
        this.tabChanged(this, 'results')
    }

    render() {
        if(this.state.aiMode) {
            return (
              <div>
                  {this.renderButtons()}
                  <br/>
                  {this.renderAIfilter()}
              </div>
            )
        }
        else {
            return (
              <div>
                  {this.renderButtons()}
                  <br/>
                  {this.renderStandardFilters()}
              </div>
            )
        }
    }

    getFiltersStatus() {
        var retVal = 0;
        Object.keys(this.filterStores).forEach(
          (filterStore) => { retVal += this.filterStores[filterStore].getSelectCount(); }
        );
        return retVal>0;
    }

    handleFilterUpdate(filterKey, selectedFilters) {
        this.filterStores[filterKey].selectFilters(selectedFilters);
        this.setState({filterSelected:this.getFiltersStatus()})
        this.startUpdatingFilters(filterKey);
        const whereClause = this.createWhereClause()
        if(window.globalMap) {
            this.updateMap(whereClause)
            this.handleGoto(filterKey, selectedFilters[selectedFilters.length - 1])
        }
        this.props.updateResultsOnFilterUpdate(whereClause);
    }

    handleGoto(filterKey, selectFilter) {
        if(filterKey==="Hist_Dist")
            this.handleGotoArea(this.hdURL, "AREA_NAME", selectFilter)
        else
            this.handleGotoArea(this.ilURL, "LPC_NAME", selectFilter)
    }


    updateMap(whereClause) {
        for(var i=0;i<this.bldgsLayers.length;i++) {
            const buildingsLayer = window.globalMap._layers[this.bldgsLayers[i]];
            //buildingsLayer.setEditable(true);
            buildingsLayer.setDefinitionExpression(whereClause);
        }
    }

    startUpdatingFilters(changedFilter) {
        this.updatingFilterStores = {};
        Object.keys(this.filterStores).forEach(
            (filterStore) => {
                if (filterStore !== changedFilter) {
                    this.updatingFilterStores[filterStore] = true;
                }
            }
        );
        this.props.updateResultsOnFilterUpdate();
        this.setState({
            filterStores : this.filterStores,
            updatingFilterStores: this.updatingFilterStores
        });
        Object.keys(this.filterStores).forEach(
            (filterStore) => {
                if (filterStore !== changedFilter) {
                    this.getFilterUpdatesFromNetwork(this.filterStores[filterStore].filterType);
                }
            }
        );
    }

    getFilterUpdatesFromNetwork(filterType) {
        const filterURL = window.globalBuildingsURL + "/query?" +
                          "returnGeometry=false&returnDistinctValues=true";
        var whereClause = "&where=" + encodeURIComponent(this.createWhereClause());
        if(filterType==="LM_New") {
            whereClause+=" AND LM_New NOT IN ('0')"
        }
        const outputFormat = "&f=json";
        const outFields = "&outFields=" + filterType;
        const orderByFields = "&orderByFields=" + filterType;

        const url = filterURL + outputFormat + outFields + orderByFields + whereClause;
        fetch(url).then(function(response) {
            return response.json();
        })
        .then(
            (json) => this.finishUpdatingFilter(filterType, json)
        );
    }

    createWhereClause() {
        let whereClause = "";
        Object.keys(this.filterStores).forEach(
            (filterStoreName) => {
                let appliedFilters = this.filterStores[filterStoreName].getAppliedFilters();
                if (appliedFilters.length > 0) {
                    var appliedFiltersEsc = []
                    for(var i=0;i<appliedFilters.length;i++) {
                        var newStr = appliedFilters[i].replace(/'/g, "''");
                        appliedFiltersEsc[i]=newStr
                    }
                    let individualWhere = filterStoreName + " IN (" +  "\'" + appliedFiltersEsc.join("\', \'") + "\'" + ")"
                    whereClause += individualWhere + " AND ";
                }
            }
        );
        if (whereClause === "") {
            whereClause = "1=1";
        } else {
            whereClause = whereClause.substring(0, whereClause.length - " AND ".length);
        }

        return whereClause;
    }

    finishUpdatingFilter(filterType, json) {
        // read response and update state
        // change state from loading
        let filters = this.parseFilterResponse(filterType, json);
        this.filterStores[filterType].updateAvailableFilters(filters);
        //this.setstate
        delete this.updatingFilterStores[filterType];

        if (Object.keys(this.updatingFilterStores).length === 0) { //we've loaded them all
            this.setState({
                filterStores : this.filterStores,
                updatingFilterStores: {}
            });
        }
    }

    parseFilterResponse(filterType, json) {
        if (typeof json['error'] !== "undefined") {
            console.error(json['error']);
            return [];
        }

        let newFilters = [];
        json['features'].forEach(
            (feature) => {
                const filter = feature['attributes'][filterType];
                newFilters.push(filter);
            }
        );
        return newFilters;
    }

    startUpdatingResults() {
        this.resultsStore.clearResults();
        this.setState({
            updatingResults: true
        });

        const filterURL = window.globalBuildingsURL + "/query?" +
          "returnGeometry=true&returnCentroid=true";
        const whereClause = "&where=" + encodeURIComponent(this.createWhereClause());
        const outputFormat = "&f=json";
        const outFields = "&outFields=*";
        const orderByFields = "&orderByFields=Des_Addres";

        const url = filterURL + outputFormat + outFields + whereClause + orderByFields;
        fetch(url).then(function(response) {
            return response.json();
        })
          .then(
            (json) => this.finishUpdatingResults(json)
          );
    }

    finishUpdatingResults(json) {
        if (typeof json['error'] !== "undefined") {
            console.error(json['error']);
            return;
        }

        this.resultsStore.setResults(json['features']);
        this.setState({
            updatingResults: false
        });
    }

    handleGotoArea(areaUrl, areaFieldName, areaName) {
        if(areaName) {
            const whereCl = areaFieldName + "=\'" + areaName.replace(/'/g, "''") + "\'";
            const whereClause = "&where=" + encodeURIComponent(whereCl);
            const outSpatialRef = "&outSR=" + window.globalMap.spatialReference.wkid;
            const outputFormat = "&f=pgeojson";
            const outFields = "&outFields=*";

            const url = areaUrl + outputFormat + outSpatialRef + outFields + whereClause;
            fetch(url).then(function (response) {
                return response.json();
            })
              .then((json) => {this.finishGoto(json)});
        }
    }

    finishGoto(json) {

        if (typeof json['error'] !== "undefined") {
            console.error(json['error']);
            return 0;
        }
        if(json.features.length===0) return 0;

        const features = json.features;

        if (typeof this.polygonLayer !== "undefined") {
            window.globalMap.removeLayer(this.polygonLayer);
        }
        esriLoader.loadModules(["esri/graphic", "esri/Color", "esri/layers/GraphicsLayer",
            "esri/symbols/SimpleFillSymbol", "esri/symbols/SimpleLineSymbol",
            "esri/geometry/Polygon", "esri/geometry/Point"], window.globalESRIoption)
          .then(([Graphic, Color, GraphicsLayer, SimpleFillSymbol,
              SimpleLineSymbol, Polygon, Point]) => {

              const polygonSymbol = new SimpleFillSymbol(
                SimpleFillSymbol.STYLE_NULL,
                new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([115, 255, 223,1]), 2),
                new Color([255, 255, 0, 0.52])
              );
              var fill = new SimpleFillSymbol();
              this.polygonLayer = new GraphicsLayer();
              this.polygonLayer.spatialIndex = window.globalMap.spatialIndex;
              window.globalMap.addLayer(this.polygonLayer);

              if(features[0].geometry.type==="Polygon") {
                  //add polygon
                  var polygon;
                  const featureGeometry = features[0].geometry.coordinates;
                  if (featureGeometry.length > 1) { //for type MultiPolygon
                      for (var g = 0; g < featureGeometry.length; g++) {
                          polygon = new Polygon({
                              rings: featureGeometry[g],
                              spatialReference: window.globalMap.spatialReference
                          });
                          const polygonGraphic = new Graphic(polygon, polygonSymbol);
                          this.polygonLayer.add(polygonGraphic);
                      }
                  } else {
                      polygon = new Polygon({
                          rings: featureGeometry,
                          spatialReference: window.globalMap.spatialReference
                      });
                      const polygonGraphic = new Graphic(polygon, polygonSymbol);
                      this.polygonLayer.add(polygonGraphic);
                  }
                  //window.globalMap.centerAndZoom(polygon.getCentroid());
                  window.globalMap.setExtent(polygon.getExtent());
              }
          });
    }


}
